/** @jsxImportSource @emotion/react */
import { css } from '@emotion/react';
import { ClearFix } from '../mixins/_clearfix.mixin';


export default $ => css`
  .clearfix {
    ${new ClearFix().include($)}
  }
`;
